import { Flex, Form, Typography } from "antd"
import { useTranslation } from "react-i18next"

import Icon from "../../Icon"
import { normalizeMoney } from "../../Utils/normalizeMoney"
import ButtonComponent from "../Button"
import InputComponent from "../Input"

const { Text, Link } = Typography

function GiftForm({ onClose, onSubmit, initialValues, isDisabledSubmitBtn, isSubmitting = false }) {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const onFinish = (values) => {
    onSubmit(values)
  }

  function handleClearError(e, field) {
    form.setFields([
      {
        name: field,
        errors: []
      }
    ])
  }

  function onFocusHandler(e, fieldName) {
    const field = fieldName || e.target.name || e.target.id
    handleClearError(e, field)
  }

  const addErrorIcon = (error) => (
    <span>
      <Icon type={"alert_triangle_error"} /> {error}
    </span>
  )

  const validateMessages = {
    required: addErrorIcon("Required field was not filled.")
  }

  const normFile = (e) => {
    if (Array.isArray(e)) return e
    return e?.fileList
  }

  const handleBlur = (e) => form.setFieldValue("amount", normalizeMoney(e.target.value))

  return (
    <Form
      className={"with-default-error"}
      onFinish={onFinish}
      validateTrigger="onSubmit"
      validateMessages={validateMessages}
      layout="vertical"
      form={form}
      {...(initialValues ? { initialValues } : {})}
    >
      <div
      // style={{height: 'min(80vh, 624px)', overflow: 'auto'}}
      >
        <Form.Item name="comment" label={"Comment"}>
          <InputComponent />
        </Form.Item>

        <Form.Item name="amount" label={"Balance top up"} rules={[{ required: true }]}>
          <InputComponent onBlur={handleBlur} />
        </Form.Item>
      </div>
      <Flex gap={16} justify="end" style={{ padding: "32px 3px 3px 3px" }}>
        <ButtonComponent size="large" htmlType="button" onClick={onClose}>
          {t("Cancel")}
        </ButtonComponent>

        <ButtonComponent
          size="large"
          type="primary"
          htmlType="submit"
          loading={isSubmitting}
          disabled={isDisabledSubmitBtn}
        >
          {t("Gift")}
        </ButtonComponent>
      </Flex>
    </Form>
  )
}

export default GiftForm
